// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3uD70","row":"styles_row__3dSK_"};